/* screens/analytics/HiddenItemsButton.jsx — «Исключено: N» / «Скрыто: N».

   Обобщение ExclusionsManager из ABC (фидбек #16): чип над таблицей + поповер
   со списком, возврат по одному и «Вернуть все». Нет элементов — ничего не
   рисует: чип «Скрыто: 0» — шум, а не информация.

   Чип и поповер — в прежнем виде ABC (`abc-thr-btn`, `abc-thr-pop`,
   `abc-excl-*`): ABC перешёл на компонент без смены вида и поведения, а второй
   потребитель («Персонал», скрытые пары «сотрудник + должность») получает тот
   же вид. Пока сохраняется, кнопки выключены — двойной клик по «Вернуть все»
   иначе отправлял бы два запроса подряд. */
import React from 'react';
import { Icon } from '../../components/ui/Icon.jsx';
import { Popover } from '../../components/ui/Popover.jsx';

const { useState } = React;

/** Содержимое поповера — чистая функция пропсов (её видно и тестам).
 *  readOnly — только список: без кнопок возврата и «Вернуть все», внизу `readOnlyNote`
 *  (кто может вернуть). Нужен участнику без права правки: пометка «скрыта 1 пара» без
 *  списка не говорила бы, какая. */
export function HiddenItemsPanel({ items, heading, restoreTitle = 'Вернуть', busy = false,
                                   onRestore, onRestoreAll, readOnly = false, readOnlyNote }) {
  return (
    <div className="abc-thr-pop an-hidden">
      <div className="abc-thr-pop__title">{heading}</div>
      <div className="abc-excl-list">
        {items.map((e) => (
          <div className="abc-excl-item" key={e.key}>
            <span className="an-hidden__text">
              <span className="abc-excl-name" title={e.name}>{e.name}</span>
              {e.sub ? <span className="an-hidden__sub">{e.sub}</span> : null}
            </span>
            {!readOnly && (
              <button type="button" className="abc-excl-x" disabled={busy} title={restoreTitle}
                aria-label={restoreTitle + ': ' + e.name}
                onClick={() => onRestore && onRestore(e)}>
                <Icon name="close" size={12} />
              </button>
            )}
          </div>
        ))}
      </div>
      <div className="abc-thr-pop__foot">
        {readOnly ? (
          readOnlyNote ? <span className="an-hidden__note">{readOnlyNote}</span> : null
        ) : (
          <button type="button" className="abc-thr-pop__save" disabled={busy}
            onClick={() => onRestoreAll && onRestoreAll()}>
            {busy ? 'Сохраняю…' : 'Вернуть все'}
          </button>
        )}
      </div>
    </div>
  );
}

/** items [{key, name, sub?}]; label — «Исключено» / «Скрыто»; title — подсказка
 *  чипа (что значит «скрыто» в этом отчёте); heading — заголовок поповера (по
 *  умолчанию title); restoreTitle — подпись возврата строки; onRestore(item) и
 *  onRestoreAll() — могут вернуть Promise: до его завершения кнопки выключены;
 *  busy — внешний признак «идёт сохранение»; readOnly + readOnlyNote — только список
 *  (участник без права правки), вместо кнопок — кто может вернуть. */
export function HiddenItemsButton({ items, label = 'Скрыто', title, heading, restoreTitle,
                                    onRestore, onRestoreAll, busy = false, className = '',
                                    readOnly = false, readOnlyNote }) {
  const [pending, setPending] = useState(false);
  const list = Array.isArray(items) ? items : [];
  if (!list.length) return null;
  const run = (fn) => async (...args) => {
    if (!fn) return;
    setPending(true);
    try { await fn(...args); } finally { setPending(false); }
  };
  return (
    <Popover width={300} placement="bottom-end" trigger={(
      <button type="button" className={'abc-thr-btn an-hidden-btn' + (className ? ' ' + className : '')}
        title={title}>
        <Icon name="eye-off" size={12} /> {label}: {list.length}
      </button>
    )}>
      <HiddenItemsPanel items={list} heading={heading || title || label}
        restoreTitle={restoreTitle} busy={busy || pending}
        onRestore={run(onRestore)} onRestoreAll={run(onRestoreAll)}
        readOnly={readOnly} readOnlyNote={readOnlyNote} />
    </Popover>
  );
}
